import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../../customHooks/useFleetServicePatchHook";
import useGetHook from "../../../customHooks/useFleetServiceGetHook";

const EditVehicleTypeComponent = loadable(
  () => import("../../../components/Settings/VehicleType/EditVehicleType")
);
const EditVehicleType = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: ["vehicle-type"],
    url: `${APIS.VEHILCE_TYPE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["vehicle-type"],
    navigateURL: "/vehicle-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.VEHILCE_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Vehicle Type</span>
      </div>
      <EditVehicleTypeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditVehicleType;
